import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import TrendingApps from '../components/TrendingApps';
import TrendingGames from '../components/TrendingGames';
import classes from '../styles/pages/home-page.module.scss';
import elements from '../styles/settings/elements.module.scss';
import VerticalAd from "../components/adsense/VericalAd";
import HorizontalAd from "../components/adsense/HorizontalAd";
import {LEFT_SLOT, RIGHT_SLOT, SLOT1, SLOT2} from "../storage/constants/adsense";

export default function HomePage() {
    return (
        <Container fluid>
            <Row>
                <Col xl={2} className="d-none d-xl-flex justify-content-center">
                    <VerticalAd adSlot={LEFT_SLOT} />
                </Col>

                <Col xs={12} xl={8} className={elements.mainContent}>
                    <h1 className={classes.title}>Trending Apps</h1>
                    <TrendingApps />

                    <HorizontalAd adSlot={SLOT1} />

                    <h1 className={classes.title}>Trending Games</h1>
                    <TrendingGames />

                    <HorizontalAd adSlot={SLOT2} />
                </Col>

                <Col xl={2} className="d-none d-xl-flex justify-content-center">
                    <VerticalAd adSlot={RIGHT_SLOT} />
                </Col>
            </Row>
        </Container>
    );
}